var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassInput", {
    attrs: {
      value: _vm.currentValue,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      error: _vm.error,
      placeholder: _vm.placeholder,
      size: _vm.size
    },
    on: {
      input: function($event) {
        return _vm.handleInput($event)
      },
      focus: function($event) {
        return _vm.handleFocus($event)
      },
      blur: function($event) {
        return _vm.handleBlur($event)
      },
      keyup: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.handleKeyupEnter($event)
      },
      keypress: function($event) {
        return _vm.handleKeyPress($event)
      }
    },
    scopedSlots: _vm._u(
      [
        _vm.currencyPos === "right"
          ? {
              key: "suffix",
              fn: function() {
                return [
                  _vm._v("\n        " + _vm._s(_vm.currencySymbol) + "\n    ")
                ]
              },
              proxy: true
            }
          : {
              key: "prefix",
              fn: function() {
                return [
                  _vm._v("\n        " + _vm._s(_vm.currencySymbol) + "\n    ")
                ]
              },
              proxy: true
            }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }